import React, { createContext, useContext, useState, useCallback } from 'react';

const NavigationContext = createContext();

export const useNavigation = () => {
	const context = useContext(NavigationContext);
	if (!context) {
		throw new Error('useNavigation must be used within a NavigationProvider');
	}
	return context;
};

export const NavigationProvider = ({ children }) => {
	const [
		isAccordionOpen,
		setIsAccordionOpen
	] = useState(false);

	const openAccordion = useCallback(() => setIsAccordionOpen(true), []);
	const closeAccordion = useCallback(() => setIsAccordionOpen(false), []);
	const toggleAccordion = useCallback(
		() => setIsAccordionOpen((prev) => !prev),
		[]
	);

	const value = {
		isAccordionOpen,
		openAccordion,
		closeAccordion,
		toggleAccordion
	};

	return (
		<NavigationContext.Provider value={value}>
			{children}
		</NavigationContext.Provider>
	);
};
